import api from "./api";

// Tela /auditoria: trilha de "quem fez o que e quando" (admin, escopo da empresa).
const auditService = {
  list: (params = {}) => api.get("/audit", { params }).then((r) => r.data),
};

export default auditService;
